
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/preview/[id]",
      function () {
        return require("private-next-pages/preview/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/preview/[id]"])
      });
    }
  